<span mat-dialog-title>{{'main.dialogs.confirm.shortLabel' | translate}}</span>
<mat-dialog-content>
    <p>
        {{passedData.message}} <br>
        {{'main.dialogs.confirm.fullLabel' | translate}}
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">{{'main.dialogs.confirmYes.shortLabel' | translate}}</button>
    <button mat-raised-button [mat-dialog-close]="false" color="accent">{{'main.dialogs.confirmNo.shortLabel' | translate}}</button>
</mat-dialog-actions>
